module.exports = __webpack_public_path__ + "static/media/4_pricol.943ecb6f.svg";